/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_1_SrcInputs */

const en_cp_why_1_src = /** @type {(inputs: Cp_Why_1_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3-arm RCT, n=275 (Bassner et al., 2025): unrestricted AI = a "comfort trap"; scaffolded AI preserved motivation.`)
};

const id_cp_why_1_src = /** @type {(inputs: Cp_Why_1_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCT 3 lengan, n=275 (Bassner dkk., 2025): AI tanpa batas = "comfort trap"; AI ber-scaffold mempertahankan motivasi.`)
};

/**
* | output |
* | --- |
* | "3-arm RCT, n=275 (Bassner et al., 2025): unrestricted AI = a \"comfort trap\"; scaffolded AI preserved motivation." |
*
* @param {Cp_Why_1_SrcInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_1_src = /** @type {((inputs?: Cp_Why_1_SrcInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_1_SrcInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_1_src(inputs)
	return en_cp_why_1_src(inputs)
});